import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import {
  CompanyBanner,
  CompanyBannersPayload,
  NewCompanyBanner,
} from 'src/features/companyBanners/companyBanners.types';
import { UploadFileToBucket } from 'src/api/utils/uploadFileToBucket';

const companyBannersApiPath = (companyId: string) => `/companies/${companyId}/banners`;

export const getCompanyBanners = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<CompanyBannersPayload & ApiError>> => {
  return instance
    .get<CompanyBannersPayload>(companyBannersApiPath(companyId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const createCompanyBanners = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: NewCompanyBanner;
}): Promise<AxiosResponse<CompanyBanner & ApiError>> => {
  return instance
    .post<CompanyBanner>(companyBannersApiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyBannerApiPath = (companyId: string, bannerId: string) => `/companies/${companyId}/banners/${bannerId}`;

export const fetchCompanyBanner = async ({
  companyId,
  bannerId,
}: {
  companyId: string;
  bannerId: string;
}): Promise<AxiosResponse<CompanyBanner & ApiError>> => {
  return instance
    .get<CompanyBanner>(companyBannerApiPath(companyId, bannerId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
export const updateCompanyBanner = async ({
  companyId,
  bannerId,
  data,
}: {
  companyId: string;
  bannerId: string;
  data: Partial<Omit<CompanyBanner, 'id'>>;
}): Promise<AxiosResponse<CompanyBanner & ApiError>> => {
  return instance
    .post<CompanyBanner>(companyBannerApiPath(companyId, bannerId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteCompanyBanner = async ({
  companyId,
  bannerId,
}: {
  companyId: string;
  bannerId: string;
}): Promise<AxiosResponse<void & ApiError>> => {
  return instance
    .delete(companyBannerApiPath(companyId, bannerId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export type UploadBannerImage = (params: {
  companyId: string;
  bannerId: string;
  data: { filename: string };
}) => Promise<AxiosResponse<Parameters<UploadFileToBucket>[0]>>;

const companyBannerImageApiPath = (companyId: string, bannerId: string) =>
  `/companies/${companyId}/banners/${bannerId}/images/upload`;

export const uploadBannerImage: UploadBannerImage = async ({ companyId, bannerId, data }) => {
  return instance.post(companyBannerImageApiPath(companyId, bannerId), data).catch(e => e.response as never);
};
